﻿/**
 * Main collection — show a fixed filter control on small viewports when the toolbar scrolls away.
 * Also keeps the mobile filter drawer open while facets update in place.
 * Disables product-card reveal/stagger animation on collection + search grids.
 */
(function () {
  'use strict';

  var COLLECTION_LIST_SELECTOR =
    '.shopify-section--main-collection product-list, .shopify-section--main-search product-list';

  var mq = window.matchMedia('(max-width: 699px)');
  var keepFacetsDrawerOpen = false;

  function isCollectionProductList(list) {
    return !!list.closest('.shopify-section--main-collection, .shopify-section--main-search');
  }

  function showCollectionProductsInstantly(scope) {
    (scope || document).querySelectorAll(COLLECTION_LIST_SELECTOR).forEach(function (list) {
      list.querySelectorAll('[reveal-on-scroll="true"]').forEach(function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
        el.removeAttribute('reveal-on-scroll');
      });
    });
  }

  function patchProductListReveal() {
    var ProductList = customElements.get('product-list');
    if (!ProductList || ProductList.prototype.__guttelusNoRevealPatched) return;

    ProductList.prototype.__guttelusNoRevealPatched = true;

    var originalConnected = ProductList.prototype.connectedCallback;
    ProductList.prototype.connectedCallback = function () {
      if (isCollectionProductList(this)) {
        showCollectionProductsInstantly(this);
        return;
      }

      if (typeof originalConnected === 'function') {
        originalConnected.call(this);
      }
    };

    ProductList.prototype.reveal = function () {
      if (isCollectionProductList(this)) {
        showCollectionProductsInstantly(this);
        return;
      }

      var revealElements = this.querySelectorAll(
        'product-card[reveal-on-scroll="true"], .product-list__promo[reveal-on-scroll="true"]',
      );
      if (revealElements.length === 0) return;

      revealElements.forEach(function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
        el.removeAttribute('reveal-on-scroll');
      });
    };
  }

  customElements.whenDefined('product-list').then(patchProductListReveal);

  function removeOrphanedFacetsDrawers() {
    document.querySelectorAll('facets-drawer#facets-drawer, #facets-drawer').forEach(function (drawer) {
      if (drawer.parentElement === document.body) {
        drawer.remove();
      }
    });
  }

  function restoreFacetsDrawer(sectionId) {
    if (!keepFacetsDrawerOpen) {
      return;
    }

    keepFacetsDrawerOpen = false;
    removeOrphanedFacetsDrawers();

    var section = document.getElementById('shopify-section-' + sectionId);
    var drawer = section && section.querySelector('#facets-drawer');

    if (drawer && !drawer.open) {
      drawer.show();
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;

      if (!(target instanceof HTMLInputElement) || !target.name || target.name.indexOf('filter.') !== 0) {
        return;
      }

      var drawer = target.closest('#facets-drawer, facets-drawer');

      if (drawer && drawer.querySelector('facets-form[update-on-change]')) {
        keepFacetsDrawerOpen = true;
      }
    },
    true,
  );

  document.addEventListener('facet:update', function (event) {
    if (!keepFacetsDrawerOpen || !event.detail || !event.detail.url) {
      return;
    }

    var sectionId = event.detail.url.searchParams.get('section_id');
    var section = document.getElementById('shopify-section-' + sectionId);

    if (!section) {
      keepFacetsDrawerOpen = false;
      return;
    }

    var observer = new MutationObserver(function () {
      observer.disconnect();
      restoreFacetsDrawer(sectionId);
      showCollectionProductsInstantly(section);
    });

    observer.observe(section, { childList: true });

    window.setTimeout(function () {
      observer.disconnect();
      restoreFacetsDrawer(sectionId);
      showCollectionProductsInstantly(section);
    }, 3000);
  });

  document.addEventListener('shopify:section:load', function (event) {
    showCollectionProductsInstantly(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchProductListReveal();
      showCollectionProductsInstantly(document);
    });
  } else {
    patchProductListReveal();
    showCollectionProductsInstantly(document);
  }

  function initSection(section) {
    var bar = section.querySelector('[id^="main-collection-controls-"]');
    var fab = section.querySelector('.main-collection__filter-fab');
    if (!fab || !bar) return;

    var io;

    function syncVisibility(intersecting) {
      if (!mq.matches) {
        fab.classList.remove('is-visible');
        fab.setAttribute('aria-hidden', 'true');
        fab.setAttribute('tabindex', '-1');
        return;
      }
      var showFab = !intersecting;
      fab.classList.toggle('is-visible', showFab);
      fab.setAttribute('aria-hidden', showFab ? 'false' : 'true');
      fab.setAttribute('tabindex', showFab ? '0' : '-1');
    }

    function observe() {
      if (io) {
        io.disconnect();
        io = null;
      }

      if (!mq.matches) {
        syncVisibility(true);
        return;
      }

      if (!('IntersectionObserver' in window)) {
        syncVisibility(false);
        return;
      }

      io = new IntersectionObserver(
        function (entries) {
          syncVisibility(entries[0] ? entries[0].isIntersecting : false);
        },
        { root: null, threshold: 0, rootMargin: '-1px 0px 0px 0px' },
      );
      io.observe(bar);
    }

    mq.addEventListener('change', observe);
    observe();
  }

  document.querySelectorAll('[data-main-collection-section]').forEach(initSection);
})();
